// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "network.haqq",
    name: "HAQQ Wallet",
    homepage: "https://haqq.network/wallet",
    image_id: "99fe539d-6a2a-4f52-2211-42fd04a9f300",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/haqq-wallet-by-bored-gen/id6443843352",
        android: "https://play.google.com/store/apps/details?id=com.haqq.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "haqq://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map